module.exports = __webpack_public_path__ + "static/media/modelo-envio-pontos.67fe43f7.csv";